/* ============================================================
   La Nuit — complementary-products.js
   <complementary-products> hydrates the section via the Section
   Rendering API when scrolled into view.
   ============================================================ */

(function () {
  if (customElements.get('complementary-products')) return;

  class ComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.productId = this.dataset.productId;
      this.intent = this.dataset.intent || 'complementary';
      this.limit = parseInt(this.dataset.limit, 10) || 3;
      this.hydrated = false;

      if (!this.sectionId || !this.productId) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hydrated) {
            this.hydrated = true;
            observer.disconnect();
            this.hydrate();
          }
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(this);
    }

    async hydrate() {
      try {
        const url = `/recommendations/products?section_id=${encodeURIComponent(this.sectionId)}&product_id=${encodeURIComponent(this.productId)}&intent=${encodeURIComponent(this.intent)}&limit=${this.limit}`;
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('recs fetch failed');
        const html = await res.text();
        const fragment = new DOMParser().parseFromString(html, 'text/html');
        const fresh = fragment.querySelector('.complementary-products');
        if (fresh) {
          this.replaceWith(fresh);
        } else {
          this.remove();
        }
      } catch (err) {
        // Silent fallback — section just stays hidden.
        this.remove();
      }
    }
  }

  customElements.define('complementary-products', ComplementaryProducts);
})();
